import { Menu, MenuButton, MenuItem, MenuList, Portal } from '@chakra-ui/react';
import {
  CustomDateIcon,
  CustomEmailIcon,
  CustomMultiselectIcon,
  CustomNumberIcon,
  CustomPersonIcon,
  CustomPhoneIcon,
  CustomSelectIcon,
  CustomTextIcon,
  CustomUrlIcon,
} from '@sketchnote/icons';
import { AddIcon } from '@sketchnote/icons';
import cn from 'classnames';
import { useRouter } from 'next/router';
import { type } from 'os';
import { useEffect, useMemo, useState } from 'react';

import { useTableStore } from './store';

const menuItems = [
  {
    label: (
      <div className="flex font-regular text-gray-999 text-sm ">
        <CustomTextIcon wrapperClass="text-gray-400 mr-10" size={24} />
        <label className={cn('font-medium text-md w-176 text-gray-999')}>Text</label>
      </div>
    ),
    value: 'text',
    name: 'Text',
  },
  {
    label: (
      <div className="flex font-regular text-gray-999 text-sm ">
        <CustomNumberIcon wrapperClass="mr-10 text-gray-400" size={24} />
        <label className={cn('font-medium text-md w-176 text-gray-999')}>Number</label>
      </div>
    ),
    value: 'number',
    name: 'Number',
  },
  {
    label: (
      <div className="flex font-regular text-gray-999 text-sm ">
        <CustomSelectIcon wrapperClass="mr-10 text-gray-400 " size={24} />
        <label className={cn('font-medium text-md w-176 text-gray-999')}>Select</label>
      </div>
    ),
    value: 'select',
    name: 'Select',
  },
  {
    label: (
      <div className="flex font-regular text-gray-999 text-sm ">
        <CustomMultiselectIcon wrapperClass="mr-10 text-gray-400 " size={24} />
        <label className={cn('font-medium text-md w-176 text-gray-999')}>Multiselect</label>
      </div>
    ),
    value: 'multiselect',
    name: 'Multiselect',
  },
  {
    label: (
      <div className="flex font-regular text-gray-999 text-sm">
        <CustomDateIcon wrapperClass="mr-10 text-gray-400" size={24} />
        <label className={cn('font-medium text-md w-176 text-gray-999')}>Date</label>
      </div>
    ),
    value: 'date',
    name: 'Date',
  },
  {
    label: (
      <div className="flex font-regular text-gray-999 text-sm ">
        <CustomPersonIcon wrapperClass="mr-10 text-gray-400" size={24} />
        <label className={cn('font-medium text-md w-176 text-gray-999')}>Person</label>
      </div>
    ),
    value: 'person',
    name: 'Person',
  },
  {
    label: (
      <div className="flex font-regular text-gray-999 text-sm">
        <CustomUrlIcon wrapperClass="mr-10 text-gray-400" size={24} />
        <label className={cn('font-medium text-md w-176 text-gray-999')}>URL</label>
      </div>
    ),
    value: 'url',
    name: 'Url',
  },
  {
    label: (
      <div className="flex font-regular text-gray-999 text-sm ">
        <CustomEmailIcon wrapperClass="mr-10 text-gray-400 " size={24} />
        <label className={cn('font-medium text-md w-176 text-gray-999')}>Email</label>
      </div>
    ),
    value: 'email',
    name: 'Email',
  },
  {
    label: (
      <div className="flex font-regular text-gray-999 text-sm ">
        <CustomPhoneIcon wrapperClass="mr-10 text-gray-400" size={24} />
        <label className={cn('font-medium text-md w-176 text-gray-999')}>Phone</label>
      </div>
    ),
    value: 'phone',
    name: 'Phone',
  },
  // {
  //   label: (
  //     <div className="flex font-regular text-gray-999 text-sm border-t w-full items-center">
  //       <DeleteIcon wrapperClass="ml-5 mr-15 mt-10 text-gray-400" />
  //       <label className="font-medium text-md text-red-999 w-176 mt-10">Delete</label>
  //     </div>
  //   ),
  //   value: 'delete',
  // },
];

export const AddField = () => {
  const [label, setLabel] = useState('');
  const [type, setType] = useState('');
  const onAddCustomField = useTableStore((s) => s.onAddCustomField);
  const router = useRouter();
  const boardId = useMemo(() => router?.query?.view, [router?.query?.view]);
  const [isOpen, setIsOpen] = useState(false);
  const { isReadOnly } = useTableStore();
  const open = () => setIsOpen(!isOpen);
  const close = () => setIsOpen(false);

  const handleField = (menuItem) => {
    const { value, name } = menuItem;
    const fieldlabel = label || name;
    setType(value);
    setLabel('');
    onAddCustomField(value, fieldlabel, boardId);
  };

  return (
    <Menu
      isOpen={isReadOnly ? false : isOpen}
      onClose={close}
      onOpen={open}
      direction="ltr"
      placement="right-end"
      offset={[200, 10]}
    >
      <MenuButton>
        <span className=" text-3xl font-regular text-gray-800 hover:text-gray-500">+</span>
      </MenuButton>
      <Portal>
        <div className="more-menu-popover">
          <MenuList className="bg-white min-w-160 p-6 flex-col inline-flex  w-full rounded-lg shadow-sm transform scale-75">
            <div className="flex flex-col items-center pl-10">
              <div className="flex font-regular text-gray-999 text-sm bg-white rounded-sm mb-10 items-center w-full">
                <CustomTextIcon wrapperClass="text-gray-400 mr-10" size={24} />

                <input
                  className="mt-4 text-gray-500 h-36 bg-white pl-5 "
                  placeholder="Enter Field Name"
                  onChange={(e) => {
                    setLabel(e.target.value);
                  }}
                  value={label}
                  // onKeyDown={(e) => {
                  //   if (e.key === 'Enter') {
                  //     onCloseMenu?.(labelStr);
                  //     onupdateFieldLabel?.(labelStr);
                  //   }
                  // }}
                />
              </div>
              <div className="flex mb-16 border-b w-full"></div>
            </div>
            {menuItems.map((menuItem) => (
              <MenuItem
                onClick={handleField.bind(null, menuItem)}
                key={menuItem.name}
                className=" active:text-primary-500 font-medium text-xs flex px-8 py-7 w-full rounded-sm min-w-btn-lg focus:bg-gray-100 hover:bg-gray-100 cursor-pointer align-middle"
              >
                {menuItem.label}
              </MenuItem>
            ))}
          </MenuList>
        </div>
      </Portal>
    </Menu>
  );
};
